const masqueTelephone = (telephone: string) => {
	return telephone.replace(/(.{2})/g, '$1 ')
}

export default masqueTelephone
